// extracted by mini-css-extract-plugin
module.exports = {"bottomLinks":"BottomLinks_bottomLinks__3TcsQ"};